import { IoNotificationsOutline } from 'react-icons/io5';
import { HiShoppingBag, HiXMark } from 'react-icons/hi2';
import { useEffect, useState } from 'react';
import { NotificationList } from '@src/pages/notification';
import { Modal } from '@src/components/ui';
import { Badge, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { useLazyGetCartQuery } from '@src/services/cart/cart.slice';
import { useLazyGetNotificationsQuery } from '@src/services/notification/notificationApiSlice';

export default function InnerNavbar() {
    const [showNotifications, setShowNotifications] = useState(false);
    const [getCartList, { data: cartData }] = useLazyGetCartQuery();
    const [getNotificationList, { data: notificationData }] =
        useLazyGetNotificationsQuery();
    useEffect(() => {
        getNotificationList({ page: 1, limit: 1 });
        getCartList();
    }, []);
    return (
        <>
            <div className="mt-7 ms-auto me-2 flex items-center gap-2">
                <div className="flex items-center gap-4 p-2 rounded-xl bg-[#4C4C4C0A]">
                    <Badge
                        size="small"
                        count={notificationData?.total}
                        className="border rounded-3xl p-2 border-[#FF3838]"
                    >
                        <IoNotificationsOutline
                            className="text-[#FF3838] hover:transform hover:scale-110 transition-all ease-in-out cursor-pointer"
                            size={22}
                            onClick={() => setShowNotifications(true)}
                        />
                    </Badge>
                    <Badge
                        size="small"
                        count={
                            (cartData?.items?.reduce(
                                (sum, item) => sum + item.quantity,
                                0
                            ) || 0) + (cartData?.topUpItems?.length || 0)
                        }
                        color="#233ac2"
                        className="border rounded-3xl p-2 border-primary-main"
                    >
                        <Link to="/dashboard/cart" className="flex">
                            <HiShoppingBag
                                className="text-primary-main hover:transform hover:scale-110 transition-all ease-in-out cursor-pointer"
                                size={22}
                            />
                        </Link>
                    </Badge>
                </div>
                {/* <NavbarInfo /> */}
            </div>
            {showNotifications && (
                <Modal
                    open={showNotifications}
                    onCancel={() => setShowNotifications(false)}
                    title={
                        <span className="text-xl font-medium">
                            Notifications
                        </span>
                    }
                    icon=""
                    drawerProps={{
                        classNames: {
                            header: '!p-0 !border-b !border-solid !border-b-lightBorder [&_.ant-drawer-header-title]:px-6  [&_.ant-drawer-header-title]:py-4',
                            body: '',
                            footer: '',
                        },
                    }}
                >
                    <NotificationList />
                </Modal>
            )}
        </>
    );
}
